// extracted by mini-css-extract-plugin
export default {"fullCalendar":"WeekScheduler_fullCalendar__HUKX9"};